"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function audr(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M7.06756 9.94798L9.77506 11.388L11.2151 10.668L7.77331 8.80348V5.51998L14.3906 8.95498L15.8306 8.23498L7.35556 3.79198C7.25892 3.74121 7.15081 3.71626 7.04169 3.71956C6.93257 3.72285 6.82616 3.75428 6.73276 3.81078C6.63936 3.86729 6.56214 3.94697 6.50858 4.0421C6.45502 4.13722 6.42694 4.24457 6.42706 4.35373V8.90398C6.42931 9.34423 6.67606 9.74698 7.06756 9.94798ZM17.3853 9.18448C17.2917 9.09356 17.1723 9.03374 17.0435 9.0132C16.9146 8.99267 16.7825 9.01241 16.6653 9.06973L7.06756 14.052C6.67381 14.2545 6.42631 14.6602 6.42706 15.1035V19.6462C6.42694 19.7554 6.45502 19.8627 6.50858 19.9579C6.56214 20.053 6.63936 20.1327 6.73276 20.1892C6.82616 20.2457 6.93257 20.2771 7.04169 20.2804C7.15081 20.2837 7.25892 20.2588 7.35556 20.208L16.9316 15.24C17.3313 15.033 17.5796 14.6175 17.5728 14.1675V9.63148C17.5728 9.54825 17.5563 9.46586 17.5241 9.38911C17.4919 9.31236 17.4447 9.24279 17.3853 9.18448ZM16.2333 14.088L7.77331 18.48V15.1965L16.2333 10.8045V14.088Z", fill: color }));
}
exports["default"] = audr;
//# sourceMappingURL=audr.js.map